import React from 'react';

import { CheckboxProps, Checkbox as MuiCheckbox } from '@mui/material';

import { CheckedIcon, Icon } from './styled';

export const Checkbox: React.FC<CheckboxProps> = (props) => {
  return (
    <MuiCheckbox {...props} checkedIcon={<CheckedIcon />} icon={<Icon />} />
  );
};
